module.exports = __webpack_public_path__ + "static/img/T7201_old.947357fd.png";